
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.93 21.58a6.268 6.268 0 01-4.133-1.556L1.64 22.18v-5.39h5.39l-2.168 2.168a4.763 4.763 0 003.066 1.126 4.798 4.798 0 004.552-3.294l1.42.467c-.833 2.51-3.187 4.324-5.972 4.324zM8.013 3.413c-.876 0-1.594.717-1.594 1.594 0 .877.718 1.594 1.594 1.594.877 0 1.595-.717 1.595-1.594 0-.877-.718-1.594-1.595-1.594zm0 7.971c-2.152 0-4.623 1.028-4.783 1.595h9.566c-.183-.574-2.638-1.595-4.783-1.595zm0-9.566a3.188 3.188 0 110 6.378 3.188 3.188 0 110-6.378zm0 7.972c2.129 0 6.378 1.068 6.378 3.189v1.594H1.636v-1.595c0-2.12 4.249-3.188 6.377-3.188z","fill":"#000"}})])
          )
        }
      }
    